import type { Vendor, Category } from '../../../../types';
import { useIsDesktop } from '../../../../hooks/useIsDesktop';
import { Mobile } from './Mobile';
import { Desktop } from './Desktop';

interface Props {
  vendor: Vendor;
  category?: Category | undefined;
  locationName?: string | undefined;
  /** Force a variant. When omitted, falls through to useIsDesktop. */
  variant?: 'mobile' | 'desktop' | undefined;
  onBack: () => void;
  onShowOnMap?: ((vendor: Vendor) => void) | undefined;
}

export function VendorDetail(props: Props) {
  const isDesktop = useIsDesktop();
  const desktop = props.variant ? props.variant === 'desktop' : isDesktop;
  if (desktop) {
    return (
      <Desktop
        vendor={props.vendor}
        category={props.category}
        locationName={props.locationName}
        onBack={props.onBack}
      />
    );
  }
  return (
    <Mobile
      vendor={props.vendor}
      category={props.category}
      locationName={props.locationName}
      onBack={props.onBack}
      onShowOnMap={props.onShowOnMap}
    />
  );
}
